import { forwardRef, Icon, IconProps } from "@chakra-ui/react";
export default forwardRef<IconProps, "svg">((props, svgRef) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={18}
    fill="none"
    viewBox="0 0 21 18"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.772.85a8.356 8.356 0 013.577 2.109l2.538 2.386V3.89a.79.79 0 011.58 0v3.668a.79.79 0 01-.79.79H16.01a.79.79 0 110-1.58l1.41-.001-2.504-2.353A6.315 6.315 0 004.496 6.77a1.02 1.02 0 11-1.924-.68 8.357 8.357 0 0110.2-5.24zM.652 9.923l.093-.115.068-.067.109-.082.11-.064.116-.05.131-.036.095-.016.083-.006h3.7a1.02 1.02 0 010 2.042H4.065l1.927 1.81a6.317 6.317 0 008.661.256 6.315 6.315 0 001.758-2.613 1.021 1.021 0 011.925.68A8.358 8.358 0 014.56 14.794l-2.05-1.927v1.309a1.02 1.02 0 11-2.042 0v-3.703l.005-.068.03-.162.005-.02a.998.998 0 01.144-.3z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M10.373 3.251a.84.84 0 01.839.84v.164a2.788 2.788 0 011.656 1.048c.33.426.15 1.04-.342 1.248a.833.833 0 01-.895-.174l-.084-.095c-.195-.265-.543-.54-1.128-.54a1.7 1.7 0 00-.833.223c-.252.152-.429.38-.429.712 0 .16.036.29.104.4.07.113.178.217.336.32.202.13.471.249.816.376l.45.159.255.085c.954.33 1.571.744 1.949 1.232.38.49.505 1.037.505 1.607 0 1.083-.521 1.738-1.095 2.126a3.59 3.59 0 01-1.265.516v.163a.84.84 0 01-1.68 0v-.21a3.271 3.271 0 01-2.084-1.689c-.226-.434.031-.98.463-1.149a.86.86 0 01.987.26l.07.108c.238.453.689.99 1.522.99.34 0 .694-.09.96-.272a.966.966 0 00.435-.835c0-.328-.116-.572-.374-.791-.23-.196-.574-.371-1.055-.558l-.407-.148c-.42-.145-1.01-.35-1.512-.704-.533-.375-.978-.926-1.043-1.757l-.008-.238.014-.187.032-.203c.037-.19.105-.428.229-.675.265-.53.782-1.098 1.772-1.344V4.09a.84.84 0 01.84-.84z"
    />
  </Icon>
));
